module.exports = __webpack_public_path__ + "static/CIW_Part5-dea0160597170942d54b96466406e82c.pdf";